import { createConverterRulesArray } from 'common/builder/components/chart/FlowChart/lib/utils/createConverterRulesArray'
import { FlowChartTrigger } from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'
import { IFlowTrigger } from 'common/flow/flowInterfaces'

import { AiIntentGenericTriggerConverterRule } from './converterRules/AiIntentGenericTriggerConverterRule'
import { CommonGenericTriggerConverterRule } from './converterRules/CommonGenericTriggerConverterRule'
import { ExternalTriggerGenericTriggerConverterRule } from './converterRules/ExternalTriggerGenericTriggerConverterRule'
import { KeywordGenericTriggerConverterRule } from './converterRules/KeywordGenericTriggerConverterRule'
import { RuleGenericTriggerConverterRule } from './converterRules/RuleGenericTriggerConverterRule'
import { TikTokAdsGenericTriggerConverterRule } from './converterRules/TikTokAdsGenericTriggerConverterRule'

export const GenericTriggerConversionRules = createConverterRulesArray<
  IFlowTrigger,
  FlowChartTrigger
>(
  [
    RuleGenericTriggerConverterRule,
    KeywordGenericTriggerConverterRule,
    AiIntentGenericTriggerConverterRule,
    TikTokAdsGenericTriggerConverterRule,
    ExternalTriggerGenericTriggerConverterRule,
  ],
  CommonGenericTriggerConverterRule,
)
